import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import { TrackableFile, UpdateTrackableFile } from 'types/trackables';

import { useAPI } from 'hooks/api/useAPI';

type UseUpdateTrackableFileParams = {
  trackable_list_id: string;
  trackable_item_id: string;
  trackable_file_id: string;
  data: UpdateTrackableFile;
};

export function useUpdateTrackableFile({
  onSuccess,
  onError,
  onSettled,
  ...options
}: UseMutationOptions<TrackableFile, APIError, UseUpdateTrackableFileParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ trackable_list_id, trackable_item_id, trackable_file_id, data }: UseUpdateTrackableFileParams) => {
      const response = await client.put(`/apps/${applicationID}/trackables/${trackable_list_id}/items/${trackable_item_id}/files/${trackable_file_id}`, data);
      return response.data;
    },
    {
      ...options,
      onSuccess: (...args) => {
        onSuccess?.(...args);
        queryClient.invalidateQueries(['trackable-files']);
      },
      onError,
      onSettled,
    }
  );
}